module.exports = __webpack_public_path__ + "static/img/Boy-2.cbe478e9.png";